module.exports = __webpack_public_path__ + "static/Burst_2-eebce2b201e204ba35d89b1e3cc01c9f.jpg";